import { z, toJSONSchema } from "zod";

export const judgeScoreSchema = z.object({
  score: z.number().int().min(0).max(100),
  explanation: z.string(),
});

export type JudgeScoreResult = z.infer<typeof judgeScoreSchema>;

export const judgeVoteSchema = z.object({
  judgeId: z.string(),
  score: z.number().int().min(0).max(100),
  explanation: z.string(),
});

export type JudgeVote = z.infer<typeof judgeVoteSchema>;

export const judgeTesterOutputSchema = judgeScoreSchema.extend({
  votes: z.array(judgeVoteSchema),
});

export type JudgeTesterOutput = z.infer<typeof judgeTesterOutputSchema>;

export const juryConfigSchema = z.object({
  enabled: z.boolean(),
  memberJudgeIds: z.array(z.string()),
  majorityCount: z.number().int().positive(),
  maxConsults: z.number().int().positive(),
});

export type JuryConfig = z.infer<typeof juryConfigSchema>;

export const judgeTesterRequestSchema = z.object({
  judgeId: z.string(),
  input: z.string(),
  actualOutput: z.string(),
  expectedOutput: z.string().nullable().optional().default(null),
  ruleText: z.string().nullable().optional().default(null),
  juryDepth: z.number().int().min(0).max(1).optional().default(0),
  disableJury: z.boolean().optional().default(false),
});

export type JudgeTesterRequest = z.infer<typeof judgeTesterRequestSchema>;

type JudgeScoreJsonSchema = {
  type: "object";
  properties: Record<string, unknown>;
  required: string[];
  additionalProperties: boolean;
};

// JSON Schema passed to OpenRouter structured outputs. Derived directly from the Zod schema to avoid drift.
export const judgeScoreJsonSchema = toJSONSchema(judgeScoreSchema, {
  target: "openapi-3.0",
  cycles: "throw",
  reused: "inline",
}) as JudgeScoreJsonSchema;
